import { useTranslation } from "react-i18next";

export default function ImprovementPlanRecommendationsTab() {
    const { t } = useTranslation(["improvementPlan"]);

    return (
        <p className="text-muted mb-0">
            {t("improvementPlan:tabsContent.pending")}
        </p>
    );
}
